import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { MuiXHelpers_createElement } from "../../fable_modules/Feliz.MuiX.DatePickers.6.9.2-alpha.6/Mui.fs.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getLocale } from "../../Locale.js";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { defaultOf } from "../../fable_modules/fable-library-js.4.24.0/Util.js";

export function Activities_NotifyDatePicker_Z4AAA61F6(activities_NotifyDatePicker_Z4AAA61F6InputProps) {
    let value_5, elems;
    const onChange = activities_NotifyDatePicker_Z4AAA61F6InputProps.onChange;
    const maxDate = activities_NotifyDatePicker_Z4AAA61F6InputProps.maxDate;
    const value = activities_NotifyDatePicker_Z4AAA61F6InputProps.value;
    const ctx = reactApi.useContext(ctx_1);
    return MuiXHelpers_createElement(LocalizationProvider, [["adapterLocale", getLocale(ctx.Language)], ["localeText", ctx.Locale], (value_5 = AdapterDateFns, ["dateAdapter", value_5]), (elems = [MuiXHelpers_createElement(DateTimePicker, [["label", ctx.Locale.t("Services.NotificationDate")], ["disablePast", true], ["maxDate", maxDate], ["value", defaultArg(value, defaultOf())], ["onChange", (delegateArg, delegateArg_1) => {
        onChange(delegateArg, delegateArg_1);
    }], ["slotProps", {
        textField: {
            fullWidth: true,
        },
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

